export default {
	'system.menu.title': '菜单权限',
	'system.menu.menu_id': '菜单编号',
	'system.menu.menu_name': '菜单名称',
	'system.menu.parent_id': '上级菜单',
	'system.menu.order_num': '显示顺序',
	'system.menu.path': '路由地址',
	'system.menu.component': '组件路径',
	'system.menu.query': '路由参数',
	'system.menu.is_frame': '是否为外链',
	'system.menu.is_cache': '是否缓存',
	'system.menu.menu_type': '菜单类型',
	'system.menu.visible': '显示状态',
	'system.menu.status': '菜单状态',
	'system.menu.perms': '权限标识',
	'system.menu.icon': '菜单图标',
	'system.menu.create_by': '创建者',
	'system.menu.create_time': '创建时间',
	'system.menu.update_by': '更新者',
	'system.menu.update_time': '更新时间',
	'system.menu.remark': '备注',
};
